<!-- QRの読み取りで不正な文字列だった場合などのダイアログ fnc毎に表示するエラータイトルは変わる -->
<template>
  <div class="content-center">
    <!-- 利用開始日UI・注意書き -->
    <TheBbStartDateSelect :onSelectedDate="setStartDateOfUse" :isDateLimitedIn="isValidDate"
      :startDateOfUse="startDateOfUse" :masterBook="masterBook" />
    <!-- 利用開始日UI・注意書き -->

    <p class="error-block">
      ※引き換え後の利用開始日変更はできませんので<br />ご注意ください
    </p>
    <br />
    <br />
    <br />
    <br />
    <br />

    <ItemButton label="クーポンを引き換える" actionType="btn-primary" @clicked="clickedIssue()" :disabled="!isValidDate" />
  </div>

  <DialogRedemptionConfirmation ref="DialogRedemptionConfirmation" @clicked="createBookGroupWithVoucher" />

  <DialogQRFail ref="QRFail" :failTitle="failTitle" @clicked="backToVoucherInput" />
</template>

<script>
import dateService from "@/services/bookBookingDate";
import nativeHandlerService from "@/services/nativeHandler";

import { mapGetters } from "vuex";

import API from "@/API";

export default {
  name: "DialogSelectDate",
  data() {
    return {
      startDateOfUse: "",
      failTitle: "読み込みがうまくいきませんでした",
    };
  },
  props: {
    requestCode: {
      type: String,
      required: true,
    },
  },
  methods: {
    async setStartDateOfUse(selectedDate) {
      this.startDateOfUse = selectedDate;
    },
    async clickedIssue() {
      this.$refs.DialogRedemptionConfirmation.openDialog();
    },

    async createBookGroupWithVoucher() {
      console.log(
        "createBookGroupWithVoucher this.requestCode :>> ",
        this.requestCode
      );
      try {
        // POST API
        await API.createBookGroupWithVoucher({
          code: this.requestCode,
          started_at: this.$moment(new Date(this.startDateOfUse)).format(),
        });

        // 計測用ネイティブコール
        await nativeHandlerService.ncCouponComplete(this.requestCode);

        this.$router.push({
          name: "BookBookingResult",
          params: {
            id: this.masterBook.id,
            book_group_id: this.bookGroup.id,
          },
          query: {
            voucher: true,
            language: this.$store.getters["common/lang"],
          },
        });
      } catch (err) {
        console.log("err :>> ", err);
        // エラーの場合は400 bad_request 既に引換済み
        this.failTitle = "引き換え済みのコードです";
        this.$refs.QRFail.openDialog();
      }
    },

    backToVoucherInput() {
      this.$emit("parentMethod");
    },
  },
  computed: {
    isValidDate() {
      return dateService.checkIsValidDate(
        this.masterBook.purchase_started_at,
        this.masterBook.purchase_limited_at,
        this.startDateOfUse
      );
    },
    ...mapGetters("ticketing", ["bookGroup", "masterBook"]),
  },
};
</script>
<style lang="scss" scoped>
.content-center {
  position: absolute;
  width: 95%;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
}

.error-block {
  margin: 0 0 10px 0;
  font-size: 13px;
  font-weight: bold;
  text-align: right;
  line-height: 17px;
  color: #ff3333;
}
</style>
